const USER_ACTIVITY_URL =
    process.env.REACT_APP_USER_ACTIVITY_URL ||
    "https://admin.rippaday.com/api/user-activity";

export async function recordLoginActivity(idToken) {
    if (!idToken) {
        return;
    }

    const response = await fetch(USER_ACTIVITY_URL, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${idToken}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            eventType: "login",
            client: {
                name: "RippaDay web",
                version: process.env.REACT_APP_VERSION || "web",
                platform: "Web",
                operatingSystem: navigator.platform || "",
                browser: "",
                language: navigator.language || "",
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
            },
        }),
        keepalive: true,
    });

    if (!response.ok) {
        throw new Error(`Could not record login activity (${response.status}).`);
    }
}
